import styled from "styled-components";
import {
    AssignmentOutlined as AssignmentOutlinedIcon,
    EventOutlined as EventOutlinedIcon,
    SchoolOutlined as SchoolOutlinedIcon,
    ViewWeekOutlined as ViewWeekOutlinedIcon,
    WorkOutline as WorkOutlineIcon
} from "@material-ui/icons";

export const Description = styled.p`
  white-space: pre-line;
  font-size: 1rem;
  line-height: 1.5;
  color: #000;
  opacity: 60%;
`

export const JobDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
  
  &:first-child {
    padding-top: 0;
  }
  
  &:last-child {
    border-bottom: none;
  }
`

export const JobDetailsItem = styled.div`
  display: flex;
  align-items: center;
  width: 48%;
`

export const JobDetailsItemContent = styled.div`
  margin-left: 1rem;
`

export const JobDetailsItemTitle = styled.div`
  margin-bottom: 0.25rem;
  color: #000;
  opacity: 60%;
  font-size: 0.8rem;
  line-height: 1.4;
  font-weight: 700;
`

export const StyledAssignmentOutlinedIcon = styled(AssignmentOutlinedIcon)`
  color: #0B4598;
`;

export const StyledEventOutlinedIcon = styled(EventOutlinedIcon)`
  color: #0B4598;
`;

export const StyledSchoolOutlinedIcon = styled(SchoolOutlinedIcon)`
  color: #0B4598;
`;

export const StyledViewWeekOutlinedIcon = styled(ViewWeekOutlinedIcon)`
  color: #0B4598;
`;

export const StyledWorkOutlineIcon = styled(WorkOutlineIcon)`
  color: #0B4598;
`;
